import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { alertV2 } from "../../api";
import { toast } from "react-toastify";
import { parserAPI } from "../../utils/parser";
import { formatDateOnly } from "../../utils/helper.jsx";
import { formatNumber } from "chart.js/helpers";
import DataTable from "react-data-table-component";
import { Card, CardBody } from "../card/card";
import ImageViewer from "../ImageViewer";

export default function MachineImpactHistory({ machine }) {
  const navigate = useNavigate();
  const { config } = useAuth();
  const [events, setEvents] = React.useState([]);
  async function getAction() {
    let allEvents = [];
    try {
      const res = await alertV2.listActionMachine({ machine_id: machine.id });
      const actions = await parserAPI(res);
      let events = [];
      actions.map((action) => {
        //filter action.alertlogs with event_action = 'Closed'
        const closedEvents = action.alertlogs.filter(
          (log) => log.event_action === "Closed"
        );
        //get latest event_date in action.alertlogs with event_action = 'Closed'
        if (closedEvents.length > 0) {
          const latestAction = closedEvents.reduce((prev, current) => {
            return prev.event_date > current.event_date ? prev : current;
          });
          console.log({ latestAction });

          events.push(latestAction);
        }
      });
      console.log({ events });
      allEvents = events.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
      setEvents(allEvents);
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  React.useEffect(() => {
    getAction();
  }, []);
  function gotoAlertDetail(id) {
    navigate(`/alert/list/${id}`);
  }
  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div>
              Successes : <b>{data.action?.action_work}</b>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  const columns = [
    // ...generateLocationWording().map((w, i) => ({
    //   name: w,
    //   selector: (row) => printLocation(row.location_arr[i]),
    // })),
    {
      name: "Alert ID",
      selector: (row) => row.alert_id,
    },
    {
      name: "Date & Time",
      selector: (row) => row.event_date,
      cell: (row) => <div>{formatDateOnly(row.event_date)}</div>,
    },
    {
      name: "Last Updated",
      selector: (row) => row.event_date,
      cell: (row) => <div> {formatDateOnly(row.action?.created_at)}</div>,
    },
    {
      name: "Unplanned Downtime Saved",
      selector: (row) => row.event_date,
      cell: (row) => <div> {row.action?.unplanned_downtime} Hrs</div>,
    },
    {
      name: "Cost Saved",
      selector: (row) => row.event_date,
      cell: (row) => (
        <div>
          {" "}
          {config?.currency} {formatNumber(row.action?.maintenance_cost)}
        </div>
      ),
    },
    {
      name: "Man-hour Saved",
      selector: (row) => row.event_date,
      cell: (row) => <div> {row.action?.man_hour_saved}</div>,
    },
  ];
  return (
    <>
      <div className="position-relative">
        <h4>Success & Impact History</h4>
        <hr />
        <DataTable
          expandableRows
          highlightOnHover
          expandableRowsComponent={ExpandedComponent}
          theme="dark"
          columns={columns}
          data={events}
          pagination
        />
      </div>
    </>
  );
}
